<template>
    <div class="row step-3">
        <div class="col-12">
            <div class="row form-section-header my-4">
                <div class="col-12">
                    <h6 class="form-section-header-title">{{ $t('Arve') }}</h6>
                </div>
            </div>

            <!-- Top choices -->
            <p>
                {{ $t('Arve koopia saadetakse e-postile') }} {{ regData.user ? regData.user.email : '' }}. {{
                    $t('Sind lisatakse osavõtjate nimekirja peale osavõtutasu maksmist')
                }}
            </p>

            <div class="row my-2 mb-3">
                <div class="col-12">
                    <div class="custom-control custom-checkbox">
                        <input class="custom-control-input"
                               type="checkbox"
                               :class="{'is-invalid': regForm.hasErrors('terms_accepted')}"
                               :required="regForm.isRequired('terms_accepted')"
                               v-model="regData.terms_accepted">
                        <label class="custom-control-label" v-on:click="regData.terms_accepted = !regData.terms_accepted">
                            <strong>{{ $t('Olen tutvunud võistluse juhendiga ja aksepteerin osavõtutingimusi') }}</strong>
                        </label>
                        <div class="invalid-feedback" v-for="error in regForm.getErrors('terms_accepted')">
                            <div class="alert alert-danger">{{ error }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row my-2">
                <div class="col-12">
                    <div class="custom-control custom-checkbox">
                        <input class="custom-control-input"
                               type="checkbox"
                               v-model="invoice.is_company">
                        <label class="custom-control-label" v-on:click="invoice.is_company = !invoice.is_company">
                            {{ $t('Soovin arvet ettevõtte nimele') }}
                        </label>
                    </div>
                </div>
            </div>

            <!-- Arve -->
            <!-- Bottom -->
            <div class="row my-2" v-if="invoice.is_company">
                <div class="col-sm-12 col-md-6 form p-3">
                    <form action="#">
                        <div class="form-row">
                            <div class="form-group col-12">
                                <label class="field-label">{{ $t('Maksja nimi') }}</label>
                                <input class="form-control"
                                       :class="{'is-invalid': invoiceRecForm.hasErrors('name')}"
                                       :required="invoiceRecForm.isRequired('name')"
                                       type="text"
                                       v-model="invoice.name">
                                <div class="invalid-feedback" v-for="error in invoiceRecForm.getErrors('name')">
                                    <div class="alert alert-danger">{{ error }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12">
                                <label class="field-label">{{ $t('KMKR või registrikood') }}</label>
                                <input class="form-control"
                                       :class="{'is-invalid': invoiceRecForm.hasErrors('reg_code')}"
                                       :required="invoiceRecForm.isRequired('reg_code')"
                                       type="text"
                                       v-model="invoice.reg_code">
                                <div class="invalid-feedback" v-for="error in invoiceRecForm.getErrors('reg_code')">
                                    <div class="alert alert-danger">{{ error }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12">
                                <label class="field-label">{{ $t('E-post') }}</label>
                                <input class="form-control"
                                       :class="{'is-invalid': invoiceRecForm.hasErrors('email')}"
                                       :required="invoiceRecForm.isRequired('email')"
                                       type="email"
                                       v-model="invoice.email">
                                <div class="invalid-feedback" v-for="error in invoiceRecForm.getErrors('email')">
                                    <div class="alert alert-danger">{{ error }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12">
                                <label class="field-label">{{ $t('Telefon') }}</label>
                                <input class="form-control"
                                       :class="{'is-invalid': invoiceRecForm.hasErrors('phone')}"
                                       :required="invoiceRecForm.isRequired('phone')"
                                       type="text"
                                       v-model="invoice.phone">
                                <div class="invalid-feedback" v-for="error in invoiceRecForm.getErrors('phone')">
                                    <div class="alert alert-danger">{{ error }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12">
                                <label class="field-label">{{ $t('Tänav, maja ja korteri nr') }}</label>
                                <input class="form-control"
                                       :class="{'is-invalid': invoiceRecForm.hasErrors('address')}"
                                       :required="invoiceRecForm.isRequired('address')"
                                       type="text"
                                       v-model="invoice.address">
                                <div class="invalid-feedback" v-for="error in invoiceRecForm.getErrors('address')">
                                    <div class="alert alert-danger">{{ error }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12">
                                <label class="field-label">{{ $t('Linn/asula') }}</label>
                                <input class="form-control"
                                       :class="{'is-invalid': invoiceRecForm.hasErrors('city')}"
                                       :required="invoiceRecForm.isRequired('city')"
                                       type="text"
                                       v-model="invoice.city">
                                <div class="invalid-feedback" v-for="error in invoiceRecForm.getErrors('city')">
                                    <div class="alert alert-danger">{{ error }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12">
                                <label class="field-label">{{ $t('Maakond') }}</label>
                                <input class="form-control"
                                       :class="{'is-invalid': invoiceRecForm.hasErrors('county')}"
                                       :required="invoiceRecForm.isRequired('county')"
                                       type="text"
                                       v-model="invoice.county">
                                <div class="invalid-feedback" v-for="error in invoiceRecForm.getErrors('county')">
                                    <div class="alert alert-danger">{{ error }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12">
                                <label class="field-label">{{ $t('Indeks') }}</label>
                                <input class="form-control"
                                       :class="{'is-invalid': invoiceRecForm.hasErrors('postal_code')}"
                                       :required="invoiceRecForm.isRequired('postal_code')"
                                       type="text"
                                       v-model="invoice.postal_code">
                                <div class="invalid-feedback" v-for="error in invoiceRecForm.getErrors('postal_code')">
                                    <div class="alert alert-danger">{{ error }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12">
                                <label class="field-label">{{ $t('Riik') }}</label>
                                <select class="form-control"
                                        :class="{'is-invalid': invoiceRecForm.hasErrors('country')}"
                                        :required="invoiceRecForm.isRequired('country')"
                                        v-model="invoice.country">
                                    <option v-for="(v,k) in invoiceRecForm.fields.country._choices" :value="k">
                                        {{ v }}
                                    </option>
                                </select>
                                <div class="invalid-feedback" v-for="error in invoiceRecForm.getErrors('country')">
                                    <div class="alert alert-danger">{{ error }}</div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <!-- Bottom -->
            <div class="row my-2">
                <div class="col-12">
                    <div class="custom-control custom-checkbox">
                        <input class="custom-control-input"
                               type="checkbox"
                               v-model="invoice.show_participants">
                        <label class="custom-control-label" v-on:click="invoice.show_participants = !invoice.show_participants">
                            {{ $t('Näita osalejate nimesid arvel') }}
                        </label>
                    </div>
                </div>
            </div>
            <div class="row my-2">
                <div class="col-12">
                    <div class="custom-control custom-checkbox">
                        <input class="custom-control-input"
                               type="checkbox"
                               :class="{'is-invalid': regForm.hasErrors('accept_marketing_emails')}"
                               :required="regForm.isRequired('accept_marketing_emails')"
                               v-model="regData.user.accept_marketing_emails">
                        <label class="custom-control-label" v-on:click="regData.user.accept_marketing_emails = !regData.user.accept_marketing_emails">
                            {{ $t('Olen nõus saama infot Marathon100 poolt korraldatavate ürituste kohta e-posti teel') }}
                        </label>
                        <div class="invalid-feedback" v-for="error in regForm.getErrors('accept_marketing_emails')">
                            <div class="alert alert-danger">{{ error }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Bottom payment options -->
            <div class="row form-section-header my-4">
                <div class="col-12">
                    <h6 class="form-section-header-title">{{ $t('Palun vali makseviis') }}</h6>
                </div>
            </div>
            <div class="row my-5" v-if="invoice.price > 0">
                <div class="col-12">
                    <div class="bank-links" role="tablist">
                        <div class="bank-link" v-for="pmt in paymentMethods">
                            <a class=""
                               :class="{active: pmt.$selected, 'py-3': pmt.logo_url, 'py-3 pmt-invoice': !pmt.logo_url}"
                               v-on:click.prevent="selectPayment(pmt)"
                               href="" role="tab">
                                <img :src="pmt.logo_url" :alt="pmt.name" v-if="pmt.logo_url">
                                <span v-else class="text-uppercase">{{ pmt.title }}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row action-btn-row">
                <div class="col-sm-12 col-md-6">

                </div>
                <div class="col-sm-12 col-md-6 p-md-0">
                    <button class="btn btn-success action-btn" v-on:click="save()" :disabled="!getSelectedPayment()" v-if="getSelectedPayment() && getSelectedPayment().type !== 'invoice'">
                        {{ $t('Maksma') }}
                    </button>
                    <button class="btn btn-success action-btn" v-on:click="save()" :disabled="!getSelectedPayment()" v-if="!getSelectedPayment() || getSelectedPayment().type === 'invoice'">
                        {{ $t('Registreerin') }}
                    </button>

                    <p v-for="successMessage in notifications.successes" class="text-success my-2">
                        {{ successMessage }}
                    </p>
                    <p v-for="errorMessage in notifications.errors" class="text-danger my-2">
                        {{ errorMessage }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Filters from '../filters';
import axios from 'axios';
import Form from '../form';
import MrtNotifications from '../mrt-notifications';

export default {
    name: 'payment',
    setup() {
        return {
            Filters
        };
    },
    data() {
        return {
            regData: {user: {address: {}}},
            regForm: new Form({}),
            invoice: {},
            invoiceRecForm: new Form({}),
            paymentMethods: [],
            eqClass: {},
            notifications: new MrtNotifications(),
        };
    },
    mounted() {
        axios.get(Mrt.config.routes['account.eventRegister.step3-payment-data'])
            .then(
                (response) => {
                    this.regData = response.data.regData;
                    // Reset marketing preference to false
                    this.regData.user.accept_marketing_emails = false;
                    this.regForm = new Form(response.data.regForm);
                    this.invoice = response.data.invoice;
                    this.invoiceRecForm = new Form(response.data.invoiceRecForm);
                    this.paymentMethods = response.data.paymentMethods;

                    if (this.invoice.price === 0) {
                        this.selectPayment(this.findInvoicePayment());
                    }
                }
            );
    },
    methods: {
        selectPayment(pmtSelected) {
            this.paymentMethods.forEach((pmt) => {
                pmt.$selected = false;
            });

            pmtSelected.$selected = true;
        },
        getSelectedPayment() {
            return this.paymentMethods.find(pmt => pmt.$selected === true);
        },
        findInvoicePayment() {
            return this.paymentMethods.find(pmt => pmt.type === 'invoice');
        },
        save() {
            this.invoice.payment_type = this.getSelectedPayment() ? this.getSelectedPayment().type : null;
            this.invoice.payment_method = this.getSelectedPayment() ? this.getSelectedPayment().identifer : null;
            axios.post(Mrt.config.routes['account.eventRegister.step3-payment-data'], {invoice: this.invoice, regData: this.regData})
                .then(
                    (response) => {
                        this.regData = response.data.regData;
                        this.regForm = new Form(response.data.regForm);
                        this.invoice = response.data.invoice;
                        this.invoiceRecForm = new Form(response.data.invoiceRecForm);

                        if (this.regForm.hasErrors()) {
                            this.notifications.error(this.$t('Vormis on vead'));
                        }
                        if (this.invoiceRecForm.hasErrors()) {
                            this.notifications.error(this.$t('Vormis on vead'));
                        }

                        if (response.data.status && response.data.status === 'success') {
                            if (this.getSelectedPayment() && this.getSelectedPayment().type !== 'invoice') {
                                this.notifications.success(this.$t('Andmed on salvestatud. Teid suunatakse edasi maksma...'));
                            } else {
                                this.notifications.success(this.$t('Registreerimine õnnestus.'));
                            }

                            if (response.data.redirectTo) {
                                window.location.href = response.data.redirectTo;
                            }
                        } else if (response.data.status && response.data.status === 'error' && response.data.statusMessage) {
                            this.notifications.error(response.data.statusMessage);
                        }
                    }
                )
                .catch((err) => {
                    this.notifications.error(this.$t('Midagi läks valesti'));
                });
        }
    }
};
</script>

<style scoped>

</style>
